import type { App } from 'vue'
import AppPageFilterActiveStatus from './app-page-filter-active-status.vue'
import AppPageFilterBranch from './app-page-filter-branch.vue'
import AppPageFilterCurrency from './app-page-filter-currency.vue'
import AppPageFilterDate from './app-page-filter-date.vue'
import AppPageFilterMonthYear from './app-page-filter-month-year.vue'
import AppPageFilterProductDetail from './app-page-filter-product-detail.vue'
import AppPageFilterProductGroup from './app-page-filter-product-group.vue'
import AppPageFilterSaleType from './app-page-filter-sale-type.vue'
import AppPageFilterSearch from './app-page-filter-search.vue'
import AppPageFilterSupplier from './app-page-filter-supplier.vue'

export default {
  install (app: App) {
    app.component('AppPageFilterActiveStatus', AppPageFilterActiveStatus)
    app.component('AppPageFilterBranch', AppPageFilterBranch)
    app.component('AppPageFilterDate', AppPageFilterDate)
    app.component('AppPageFilterProductGroup', AppPageFilterProductGroup)
    app.component('AppPageFilterSaleType', AppPageFilterSaleType)
    app.component('AppPageFilterSearch', AppPageFilterSearch)
    app.component('AppPageFilterSupplier', AppPageFilterSupplier)
    app.component('AppPageFilterMonthYear', AppPageFilterMonthYear)
    app.component('AppPageFilterCurrency', AppPageFilterCurrency)
    app.component('AppPageFilterProductDetail', AppPageFilterProductDetail)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppPageFilterActiveStatus: typeof AppPageFilterActiveStatus,
    AppPageFilterBranch: typeof AppPageFilterBranch,
    AppPageFilterDate: typeof AppPageFilterDate,
    AppPageFilterProductGroup: typeof AppPageFilterProductGroup,
    AppPageFilterSaleType: typeof AppPageFilterSaleType,
    AppPageFilterSearch: typeof AppPageFilterSearch,
    AppPageFilterMonthYear: typeof AppPageFilterMonthYear,
    AppPageFilterSupplier: typeof AppPageFilterSupplier,
    AppPageFilterCurrency: typeof AppPageFilterCurrency,
    AppPageFilterProductDetail: typeof AppPageFilterProductDetail,
  }
}
